import * as api from '../api';
import { 
  FETCH_UNITS, 
  ADD_NEW_UNIT, 
  ADD_NEW_UNITS, 
  START_LOADING, 
  END_LOADING,
  UPDATE_UNIT,
  DELETE_UNIT,
  MAP_UNIT

}  from './constants'

// export const getAllUnits = () => async (dispatch) => {
//   try {
//     dispatch({ type: START_LOADING });
//     const { data } = await api.fetchUnits();
//     dispatch({ type: FETCH_UNITS, payload: data });
//     dispatch({ type: END_LOADING });
//   } catch (error) {
//     console.log(error);
//   }
// };

// export const createUnit = (unit, openSnackbar) => async (dispatch) => {
//   try {
//     const { data } = await api.addUnit(unit);
//     dispatch({ type: ADD_NEW_UNIT, payload: data });
//     openSnackbar("Unit added successfully");
//   } catch (error) {
//     console.log(error);
//   }
// };

export const createUnits = (units, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addUnits(units);
    dispatch({ type: ADD_NEW_UNITS, payload: data });
    openSnackbar("Units added successfully");
  } catch (error) {
    console.log(error);
  }
};

export const updateUnit = (id, unit, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateUnit(id, unit);
    dispatch({ type: UPDATE_UNIT, payload: data });
    openSnackbar("Unit updated successfully");
  } catch (error) {
    console.log(error);
  }
};

export const deleteUnit = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteUnit(id);
    dispatch({ type: DELETE_UNIT, payload: id });
    openSnackbar("Unit deleted successfully");
  } catch (error) {
    console.log(error);
  }
};

// export const convertUnits = (fromUnitId, toUnitId, quantity) => async (dispatch) => {
//   try {
//     const { data } = await api.convertUnits({
//       fromUnitId, 
//       toUnitId, 
//       quantity
//     });
//     return data.convertedQuantity;
//   } catch (error) {
//     console.log(error);
//   }
// };
// export const mapUnit = (unitId, baseUnitId, conversionFactor, openSnackbar) => async (dispatch) => {
//   try {
//     const { data } = await api.mapUnit({ unitId, baseUnitId, conversionFactor });
//     dispatch({ type: MAP_UNIT, payload: data });
//     openSnackbar("Unit mapped successfully");
//   } catch (error) {
//     console.log(error);
//   }
// };


export const convertUnits = (conversionData) => async (dispatch) => {
  try {
    const { data } = await api.convertUnits(conversionData);
    return data; // Return data for use in other components
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// export const mapUnit = (unitId, baseUnitId, conversionFactor, openSnackbar) => async (dispatch) => {
//   try {
//     const { data } = await api.mapUnit({ unitId, baseUnitId, conversionFactor });
//     dispatch({ type: MAP_UNIT, payload: data });
//     openSnackbar("Unit mapped successfully");
//   } catch (error) {
//     console.log(error);
//   }
// };


// unitAction.js

// export const deleteBasicUnit = (id, openSnackbar) => async (dispatch) => {
//   try {
//     const { data } = await api.deleteBasicUnit(id);
//     if (data.unit) {
//       dispatch({ type: UPDATE_UNIT, payload: data.unit });
//     } else {
//       dispatch({ type: DELETE_UNIT, payload: id });
//     }
//     openSnackbar(data.message);
//   } catch (error) {
//     console.log(error);
//     openSnackbar(error.response?.data?.message || "Error occurred");
//   }
// };

export const deleteMappedUnit = (id, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.deleteMappedUnit(id);
    if (data.unit) {
      dispatch({ type: UPDATE_UNIT, payload: data.unit });
    } else {
      dispatch({ type: DELETE_UNIT, payload: id });
    }
    openSnackbar(data.message);
  } catch (error) {
    console.log(error);
    openSnackbar(error.response?.data?.message || "Error occurred");
  }
};

export const updateBasicUnit = (id, unit, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateBasicUnit(id, unit);
    dispatch({ type: UPDATE_UNIT, payload: data });
    openSnackbar("Basic unit updated successfully");
  } catch (error) {
    console.log(error);
    openSnackbar(error.response?.data?.message || "Error occurred");
  }
};

export const updateMappedUnit = (id, unit, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateMappedUnit(id, unit);
    dispatch({ type: UPDATE_UNIT, payload: data });
    openSnackbar("Mapped unit updated successfully");
  } catch (error) {
    console.log(error);
    openSnackbar(error.response?.data?.message || "Error occurred");
  }
};

export const createUnit = (newUnit, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.createUnit(newUnit);
    dispatch({ type: "ADD_NEW_UNIT", payload: data });
    openSnackbar("Unit created successfully");
    return data;
  } catch (error) {
    const message = error.response?.data?.message || "Unable to create unit";
    openSnackbar(message);
    throw new Error(message);
  }
};

export const getAllUnits = () => async (dispatch) => {
  try {
    dispatch({ type: "START_LOADING" });
    const { data } = await api.fetchUnits();
    console.log(data)
    dispatch({ type: "FETCH_UNITS", payload: data });
    dispatch({ type: "END_LOADING" });
  } catch (error) {
    console.log(error);
  }
};

export const getUnitMappings = () => async (dispatch) => {
  try {
    const { data } = await api.fetchUnitMappings();
    console.log(data)
    dispatch({ type: "FETCH_MAPPINGS", payload: data });

  } catch (error) {
    console.log(error);
  }
};

// export const mapUnit = (mappingData, openSnackbar) => async (dispatch) => {
//   try {
//     const { data } = await api.mapUnit(mappingData);
//     dispatch({ type: "ADD_MAPPING", payload: data });

//     openSnackbar("Unit mapped successfully");
//   } catch (error) {
//     openSnackbar(error.response.data.message);
//   }
// };

export const mapUnit = (mappingData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.mapUnit(mappingData);
    if (mappingData._id) {
      dispatch({ type: "UPDATE_MAPPING", payload: data });
      openSnackbar("Unit mapping updated successfully");
    } else {
      dispatch({ type: "ADD_MAPPING", payload: data });
      openSnackbar("Unit mapped successfully");
    }
  } catch (error) {
    openSnackbar(error.response.data.message);
  }
};

// `label` is the caller's already-known display name (e.g. "kg → g") -
// optional, degrades gracefully to the old generic wording if a caller
// doesn't pass one.
export const deleteUnitMapping = (id, openSnackbar, label) => async (dispatch) => {
  try {
    await api.deleteUnitMapping(id);
    dispatch({ type: "DELETE_MAPPING", payload: id });
    openSnackbar(`Mapping${label ? ` "${label}"` : ""} deleted successfully`);
  } catch (error) {
    openSnackbar(error.response.data.message);
  }
};
